export const STATUS_OPTIONS = ["new", "contacted", "scheduled", "done", "archived"];

export const STATUS_STYLES = {
  new: "bg-gold text-navy",
  contacted: "bg-blue-500 text-white",
  scheduled: "bg-purple-500 text-white",
  done: "bg-emerald-500 text-white",
  archived: "bg-slate-400 text-white",
};

export function fmtDate(s) {
  try {
    return new Date(s).toLocaleString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return s;
  }
}
